import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAgentData from "../../utils/hooks/useAgentData";

const RecentEmails = () => {
  const [checkedItems, setCheckedItems] = useState([]);
  const { recentEmails, loading } = useAgentData();
  const navigate = useNavigate();

  const toggleCheckbox = (index) => {
    setCheckedItems((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  if (loading || !recentEmails) return null;

  const emailItems = recentEmails;

  return (
    <div className="md:w-1/2 w-full flex-col bg-white shadow-[4px_4px_47.1px_0px_#00000040] rounded-[12px] flex items-start py-4 gap-4">
      <span className="w-full border-b pb-6 pl-3 border-[#0000002B] h-[15px] text-[13px] font-semibold font-inter leading-[100%] text-black">
        Recent Emails
      </span>

      {emailItems.map((item, index) => (
        <div
          key={index}
          className="flex flex-row items-start w-full gap-1 px-3 cursor-pointer"
          onClick={() => navigate("/email-inbox")}
        >
          <input
            type="checkbox"
            checked={checkedItems.includes(index)}
            onChange={(e) => {
              e.stopPropagation();
              toggleCheckbox(index);
            }}
            className="w-[15px] h-[15px] accent-black"
          />

          <div className="flex flex-col w-full">
            <div className="flex items-center justify-between w-full">
              <span className="text-[12px] font-semibold font-inter leading-[100%] text-black">
                {item.subject}
              </span>
              <span className="text-[11px] font-medium font-inter text-[#00000073]">
                {item.timestamp}
              </span>
            </div>
            <div className="text-[10px] py-1 font-inter text-[#00000073] text-opacity-80">
              {item.snippet}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecentEmails;
